import { CarMd, Commute, PersonWalkingMd, TrainMd } from '@property.com.au/ui-kit';
import { ReactNode } from 'react';

interface CommuteSearchPromptCTA {
  icon: ReactNode;
  commute: Commute;
  ctaLabel: string;
}

const mcgCommute: CommuteSearchPromptCTA = {
  icon: <TrainMd aria-label="Commute by public transport" />,
  commute: {
    destination: {
      placeId: 'ChIJgWIaV5VC1moR-bKgR9ZfV2M',
      label: 'MCG',
    },
    method: 'public_transport',
    time: 30,
  },
  ctaLabel: '30 mins from the MCG',
};

const bondiCommute: CommuteSearchPromptCTA = {
  icon: <PersonWalkingMd aria-label="Commute by walking" />,
  commute: {
    destination: {
      placeId: 'ChIJWTi8xgGyEmsRgK0yFmh9AQU',
      label: 'Bondi Beach',
    },
    method: 'walking',
    time: 15,
  },
  ctaLabel: '15 mins from Bondi Beach',
};

const brisbaneAirportCommute: CommuteSearchPromptCTA = {
  icon: <CarMd aria-label="Commute by driving" />,
  commute: {
    destination: {
      placeId: 'ChIJo9DK_AHik2sR4IHe81qjAgU',
      label: 'Brisbane Airport',
    },
    method: 'driving',
    time: 60,
  },
  ctaLabel: '1 hour from Brisbane Airport',
};

export const commutePromptCTAs: CommuteSearchPromptCTA[] = [
  mcgCommute,
  bondiCommute,
  brisbaneAirportCommute,
];
